import React from 'react';
import { ScanIcon } from 'lucide-react';
type ScanScreenProps = {
  isScanning: boolean;
  onStartScan: () => void;
};
const ScanScreen = ({
  isScanning,
  onStartScan
}: ScanScreenProps) => {
  return <div className="flex flex-col items-center justify-center h-full" data-id="element-99">
      <div className={`relative w-64 h-64 mb-8 ${isScanning ? 'animate-pulse' : ''}`} data-id="element-100">
        <div className="absolute inset-0 bg-blue-500 bg-opacity-10 rounded-full" data-id="element-101"></div>
        <div className={`absolute inset-4 bg-blue-500 bg-opacity-20 rounded-full ${isScanning ? 'animate-ping' : ''}`} data-id="element-102"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-103">
          <div className="bg-white p-6 rounded-full shadow-md" data-id="element-104">
            <ScanIcon size={48} className="text-blue-600" data-id="element-105" />
          </div>
        </div>
      </div>
      <h2 className="text-xl font-semibold mb-3 text-gray-800" data-id="element-106">
        {isScanning ? 'Scanning for Keycard Readers...' : 'Ready to Scan'}
      </h2>
      <p className="text-gray-600 text-center mb-8 max-w-xs" data-id="element-107">
        {isScanning ? 'Please make sure your Bluetooth is enabled and readers are powered on.' : 'Press the button below to start scanning for BLE keycard readers in range.'}
      </p>
      <button onClick={onStartScan} disabled={isScanning} className={`
          px-6 py-3 rounded-lg text-white font-medium shadow-md
          ${isScanning ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800'}
        `} data-id="element-108">
        {isScanning ? 'Scanning...' : 'Start Scanning'}
      </button>
    </div>;
};
export default ScanScreen;